import {
	LOAD_FINISHES
} from './types'
// eslint-disable-next-line import/namespace,import/no-cycle
import { IFinishActions, IFinishesPayload } from './actions'
import { ILoadingAndFailure } from '../../types/interfaces'

export const initState = {
	finishes: {
		originalData: [],
		tableData: [],
		pagination: null,
		isLoading: false,
		isFailure: false
	} as IFinishesPayload & ILoadingAndFailure,
	detail: {
		data: {},
		isLoading: false,
		isFailure: false
	}
}

export default (state = initState, action: IFinishActions) => {
	switch (action.type) {
		case LOAD_FINISHES.START:
			return {
				...state,
				finishes: {
					...state.finishes,
					isFailure: false,
					isLoading: true
				} as IFinishesPayload & ILoadingAndFailure
			}
		case LOAD_FINISHES.DONE:
			return {
				...state,
				finishes: {
					...initState.finishes,
					originalData: action.payload.originalData,
					tableData: action.payload.tableData,
					pagination: action.payload.pagination
				} as IFinishesPayload & ILoadingAndFailure
			}
		case LOAD_FINISHES.FAILED:
			return {
				...state,
				finishes: {
					...initState.finishes,
					isFailure: true
				} as IFinishesPayload & ILoadingAndFailure
			}
		// case LOAD_DETAIL_FINISH.START:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: true,
		// 			isFailure: false
		// 		}
		// 	}
		// case LOAD_DETAIL_FINISH.DONE:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			data: action.payload,
		// 			isLoading: false,
		// 			isFailure: false
		// 		}
		// 	}
		// case LOAD_DETAIL_FINISH.FAILED:
		// 	return {
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: true
		// 		}
		// 	}
		// case DELETE_FINISH.START:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		list: {
		// 			...state.list,
		// 			isLoading: true,
		// 			isFailure: false
		// 		},
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: true,
		// 			isFailure: false
		// 		}
		// 	}
		// case DELETE_FINISH.DONE:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		list: {
		// 			...state.list,
		// 			isLoading: false,
		// 			isFailure: false
		// 		},
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: false
		// 		}
		// 	}
		// case DELETE_FINISH.FAILED:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		list: {
		// 			...state.list,
		// 			isLoading: false,
		// 			isFailure: true
		// 		},
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: true
		// 		}
		// 	}
		// case CREATE_FINISH.START:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: true,
		// 			isFailure: false
		// 		}
		// 	}
		// case CREATE_FINISH.DONE:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: false
		// 		}
		// 	}
		// case CREATE_FINISH.FAILED:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: true
		// 		}
		// 	}
		// case UPDATE_FINISH.START:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: true,
		// 			isFailure: false
		// 		}
		// 	}
		// case UPDATE_FINISH.DONE:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: false
		// 		}
		// 	}
		// case UPDATE_FINISH.FAILED:
		// 	return {
		// 		...initState,
		// 		...state,
		// 		detail: {
		// 			...state.detail,
		// 			isLoading: false,
		// 			isFailure: true
		// 		}
		// 	}
		default:
			return state
	}
}
